import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";
import * as styles from "./hamburger-menu.module.scss";

interface HamburgerMenuProps {
  open: boolean;
  onToggleOpen: () => void;
  ariaControls: string;
  ariaLabel: string;
  darkMode?: boolean;
  classes?: string;
}

const HamburgerMenu = (props: HamburgerMenuProps): ReactElement => {
  const {onToggleOpen, open, ariaControls, ariaLabel, darkMode, classes} =
    props;

  return (
    <button
      type="button"
      className={css(
        styles.hamburgerMenu,
        darkMode ? styles.hamburgerMenuDark : "",
        open ? styles.hamburgerMenuOpen : "",
        classes!
      )}
      onClick={onToggleOpen}
      aria-controls={ariaControls}
      aria-expanded={open}
      aria-label={ariaLabel}
    >
      <div className={css(styles.hamburgerMenu__wrapper)}>
        <div className={css(styles.hamburgerMenu__inner)} />
      </div>
    </button>
  );
};

export default HamburgerMenu;
